module.exports = __webpack_public_path__ + "img/single_video_1.3ccb0c97.png";